export default {
  CONSOLIDATE: 'CONSOLIDATE',
  TO_PAY: 'TO_PAY',
  NOT_TO_PAY: 'NOT_TO_PAY',
};
